import {ISplashService} from './splash-service.interface';
import {Check} from '@sparkware/app-utils';

export class SplashService implements ISplashService {
  constructor() {
    //document.body.style.position = 'fixed';
    document.body.classList.add('disable-animations');
  }

  computeSplashTimeInSeconds(startTime: number): number {
    return parseFloat(((performance.now() - startTime) / 1000).toFixed(2));
  }

  splashTime: number = null;

  removeSplash(): void   {
    if(!Check.isNull(this.splashTime)) {
      console.error('removeSplash called second time!');
      return;
    }
    //document.body.style.removeProperty('position');
    document.body.classList.remove('disable-animations');
    let splashPageElement = document.getElementById('splash-page');
    if(splashPageElement) {
      splashPageElement.remove();
    }
    this.splashTime = this.computeSplashTimeInSeconds(window['splashStart']);

    this._splashRemovedSubscribers.forEach(callback => callback());

  }

  private _splashRemovedSubscribers: Array<() => void> = [];
  onSplashRemoved(callback: () => void) {
    this._splashRemovedSubscribers.push(callback);
  }

}
